import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeatIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 48,
	viewBox: "0 0 43 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.891,
			cy: 29.972,
			rx: 3.76599,
			ry: 3.66732,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 26.4831,
			rx: 17,
			ry: 16.948,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 39.3929,
			rx: 2.53176,
			ry: 2.61951,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 46.2041,
			rx: 1.0127,
			ry: 1.0478,
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1.14937,
			rx: 1.0127,
			ry: 1.0478,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.5,
			cy: 7.95936,
			rx: 2.5,
			ry: 2.61951,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 44.2411C28.9 44.2411 37 36.115 37 26.1831C37 16.2511 28.9 8.125 19 8.125C9.1 8.125 1 16.2511 1 26.1831C1 36.115 9.1 44.2411 19 44.2411Z",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 25.9961C29 31.5161 24.52 35.9961 19 35.9961C13.48 35.9961 10.11 30.4361 10.11 30.4361M10.11 30.4361H14.63M10.11 30.4361V35.4361M9 25.9961C9 20.4761 13.44 15.9961 19 15.9961C25.67 15.9961 29 21.5561 29 21.5561M29 21.5561V16.5561M29 21.5561H24.56",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRepeatIcon;
